module.exports = __webpack_public_path__ + "static/media/mountains.586806cd.jpg";